import styled from 'styled-components';
import ds from 'designsystem';
import { media } from 'designsystem/index';

const SliderWrapper = styled.div`
  position: relative;
  padding: ${ds.get('metrics.m')} 0 0;
  & .slick-slider {
    overflow: hidden;
    & .slick-list {
      margin: 0 -60px;
      & .slick-slide {
        margin: 0 60px;
      }
    }
  }

  ${media.tablet`
   padding: ${ds.get('metrics.l')} 0;
  `};
`;

export default SliderWrapper;



// WEBPACK FOOTER //
// ./src/kentico-blocks/ArticleSlider/SliderWrapper.jsx